/* eslint-disable */
import BreadCrumb from 'components/BreadCrumb';
import React,{ useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import ButtonV2 from 'components/ButtonV2';
import ButtonNoBorder from 'components/ButtonNoBorder';
import ButtonSecondary from 'components/ButtonSecondary';
import DropdownV3 from 'components/DropdownV3';
import { dataCategory,listLanguage, opsiHeader, opsiButton, TypeCTA, TypeQuickReply, UrlTypeCTA, categoryTemplate, isListButtonTemplate } from 'containers/NewWaTemplate/ListDropdownData';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import _, { result } from 'lodash';
import Modal from "react-modal";
import { Alert, AlertType } from "utils/Alert";

import { listDomain } from 'utils/listDomain';

// Library
import FeatherIcon from 'feather-icons-react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { PhoneInput } from 'react-international-phone';

// components
import PhoneMediaPreview from "./PhoneMediaPreview"

// services
import applicationSvc from "services/applicationSvc";
import waTemplateSvc from "services/waTemplateSvc";

// style
import './FormCreateTemplate.scss';
import '../whatsappTemplate.scss';
import styled from "styled-components";

// image
import AlertTriangle from '_assets/svg/alert-triangle.svg';
import IconSwitch from '_assets/images/template/switch.svg'
import IconDND from '_assets/images/template/dnd.svg'

import InputDropdown from 'components/InputDropdown';
import DropdownButtonTemplate from 'components/DropdownButtonTemplate';

function AddButtonTemplate(props) {
  const {
    handlesetOptionButtons, 
    handleDropdownType, 
    setChangeButtonOptions, 
    deleteTypeQuickReply, 
    handleAddOtherButton,
    handleOptionPhoneNumber,
    handleDropdownUrlType,
    isOptionButtons,
    isChooseTypeTemplate,
    isErrorButtonText,
    listPhoneNumber,
    isOptionPhoneNumber,
    isErrorUrl,
    isVarDynamicWeb,
    onSwitchSection,
    setHeaderPreview,
    isSelectedAccount,
    val,
    idx
  } = props;
  const location = useLocation();
  const phoneInputRef = useRef();

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
    width: 250
  });

  const onDragEnd =(result, buttonList, idxButton) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(
      buttonList,
      result.source.index,
      result.destination.index
      );
      
      isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons = items;
      
      setHeaderPreview({ type: '', text: '', body: '' })
  }
  
  let countButton;
  // let filterTypeButton = [];
  if(val?.dataStructure?.buttons){
    countButton = val?.dataStructure?.buttons[0]?.buttons.length + val?.dataStructure?.buttons[1]?.buttons.length;

    // const dataSumButton = [...val?.dataStructure?.buttons[0]?.buttons, ...val?.dataStructure?.buttons[1]?.buttons];
    // const maxButtonQR = dataSumButton.filter((item) => item.type == 'QUICK_REPLY');
    if(countButton >= 4){
      isListButtonTemplate[1].menus[0].description = 'max 1 button';
    } else {
      isListButtonTemplate[1].menus[0].description = 'max 2 button';
    }
  }


  // useEffect(()=>{
  //   // if(location && isSelectedAccount.value.toLowerCase() === "marketing"){
  //   //  const resultFilter = isListButtonTemplate[0].menus.filter((item) => item.value === 'marketing_disapproval')
  //   //  console.log('resultFilter', resultFilter)
    
  //   //  if(resultFilter.length === 0){
  //   //    isListButtonTemplate[0].menus.unshift(
  //   //      {
  //   //        name: 'Marketing Disapproval',
  //   //        value: 'marketing_disapproval',
  //   //        description: `recommended (max 1 button)`
  //   //      },
  //   //    )
  //   //  }
  //   // }
  //   // if(location && isSelectedAccount.value.toLowerCase() !== "marketing"){
  //   //  const resultFilter = isListButtonTemplate[0].menus.filter((item) => item.value !== 'marketing_disapproval')
  //   //  isListButtonTemplate[0].menus = resultFilter;
  //   //  }

  // }, [isSelectedAccount])


  if(!isChooseTypeTemplate) {
    return <div>button not found</div>
  }

  if(isChooseTypeTemplate){
    return (
      <div className="wrapper_input_template mb-5 position-relative">
        <div className="d-flex align-items-center mb-2">
          <h4 className="cl-neutral400 fweight-700 fsize-14 mb-0">Buttons</h4>
          <div className="optional ms-2 cl-neutral300 fweight-600 fsize-12">Optional</div>
        </div>
        <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
        Create up to 10 buttons that allow customers to respond to your messages or take action. If you add more than 3 buttons, they will be shown in the list.
        </div>
        <div className="d-flex flex-column">
          {val?.dataStructure?.buttons && (
            <div className='w-25'>
              <DropdownButtonTemplate 
                isListSearch={isListButtonTemplate} 
                setSelectedSearch={(event)=>handlesetOptionButtons(event, idx)} 
                isSelected={isOptionButtons}
                placeholder="Add buttons"
                buttonData={val?.dataStructure?.buttons}
                className={`${countButton === 10 && 'event_disable'}`}
              />
            </div>
          )}
          {/* type button quick reply and CTA */}
          {val?.dataStructure?.buttons?.length > 0 && (
            <div className="w-100 mt-4">
              {val.dataStructure.buttons &&
                val.dataStructure.buttons.map((res, idxButton) => {
                  let buttonQR = val.dataStructure.buttons.filter(item => item.buttonType === "QUICK_REPLY" && item.buttons.length > 0);
                  let buttonCTA = val.dataStructure.buttons.filter(item => item.buttonType === "CTA" && item.buttons.length > 0);
                  console.log('buttonQR',val.dataStructure.buttons, buttonQR, buttonCTA)
                  return <div key={idxButton}>
                    {buttonQR?.length>0 && res.buttonType === "QUICK_REPLY" ? (
                      <div className='wrapper_per_section_button'>
                        {res?.buttons.length>0 && (
                          <div onClick={()=>onSwitchSection(idx)} className='d-inline-flex align-items-center mb-3 cursor-pointer'>
                            <img src={IconSwitch} className="me-2"></img>
                            <p className='cl-black weight-medium fsize-14 mb-0'>Quick Reply</p>
                          </div>
                        )}
                       <DragDropContext onDragEnd={(event)=>onDragEnd(event, res?.buttons, idxButton)}>
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              // style={getListStyle(snapshot.isDraggingOver)}
                            >
                              {res?.buttons.map((item, index) => {
                                return (
                                  <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        // style={getItemStyle(
                                        //   snapshot.isDragging,
                                        //   provided.draggableProps.style
                                        // )}
                                      >
                                      <div className={`box-extra-button wrapper_footer_text mb-3`}>
                                      {item?.typeCTA?.value === "marketing_disapproval" &&
                                      <div className='d-flex align-items-center w-100'>
                                        <div {...provided.dragHandleProps} className='cursor-pointer me-3'>
                                          <img src={IconDND} className=""></img>
                                        </div>
                                        <div className='w-100'>
                                          <div className={`row mb-3 justify-content-between`}>
                                            <div className='col-5 wrapp_input_button'>
                                              <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Type of Action</h4>
                                              <DropdownV3
                                                typeAction
                                                buttonData={val?.dataStructure?.buttons}
                                                isListSearch={TypeQuickReply} 
                                                setSelectedSearch={(value)=>handleDropdownType(value, idx, idxButton, index,val?.dataStructure?.buttons[idxButton], isOptionButtons)} 
                                                isSelected={item?.typeCTA}
                                                anySelected={isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons}
                                                placeholder="None"
                                              />
                                            </div>
                                            <div className="col-7">
                                              <div className='d-flex align-items-start w-100'>
                                                <div className='wrapp_input_button w-100'>
                                                  <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Button Text</h4>
                                                  <input
                                                    required={true}
                                                    type="text"
                                                    value={item?.text}
                                                    onChange={(e) =>
                                                      setChangeButtonOptions({
                                                        display: e.target.value,
                                                        content: item.content,
                                                        footer_marketing_disapproval: item.footer_marketing_disapproval,
                                                        idx: idx,
                                                        idxButton: idxButton,
                                                        index: index,
                                                        action: item.typeCTA.value === 'custom' ? 'custom' : 'marketing_disapproval',
                                                        term_condition: item?.term_condition,
                                                        footer_opt_out:  item?.footer_opt_out
                                                      })
                                                    }
                                                    placeholder="Enter text here"
                                                    error=""
                                                    className="form-control cl-neutral100"
                                                    maxLength={25}
                                                  />
                                                  <span className="count-char">{item?.text?.length}/25</span>
                                                </div>
                                                <div className='ms-3'>
                                                  <FeatherIcon onClick={()=>deleteTypeQuickReply(idx,idxButton,index)} icon="x" width="20" className="cursor-pointer cl-grey-smoke mb-2" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className={`row mb-3 justify-content-between w-100`}>
                                            <div className='col-5 wrapp_input_button'>
                                            <div className='d-flex align-items-start w-100'>
                                              <div className='wrapp_input_button w-100'>
                                                <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Footer Text</h4>
                                                <input
                                                  required={true}
                                                  disabled
                                                  type="text"
                                                  value={item?.footer_marketing_disapproval}
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: item.text,
                                                      footer_marketing_disapproval: item.footer_marketing_disapproval,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      action: item.typeCTA.value === 'custom' ? 'custom' : 'marketing_disapproval',
                                                      term_condition: item?.term_condition,
                                                      footer_opt_out:  item?.footer_opt_out
                                                    })
                                                  }
                                                  placeholder="Enter text here"
                                                  error=""
                                                  className="form-control cl-neutral100"
                                                />
                                              </div>
                                            </div>
                                            </div>
                                            <div className='fsize-14 fweight-500 cl-neutral400 mt-2'>
                                              <div className="check-radio-custom d-flex align-items-center fsize-14 fweight-500 cl-neutral400 break-word mb-2">
                                                <input
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: item.text,
                                                      footer_opt_out: item?.footer_opt_out,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      action: item.typeCTA.value === 'custom' ? 'custom' : 'marketing_disapproval',
                                                      term_condition: e.target.checked,
                                                      footer_marketing_disapproval: item.footer_marketing_disapproval
                                                    })
                                                  }
                                                  // onChange={()=>changeInput(item)} 
                                                  value={item?.term_condition}
                                                  checked={item?.term_condition}
                                                  // key={item.value}
                                                  type="checkbox" 
                                                  // name={item.value} 
                                                  className={`mr-10-desktop`}
                                                />
                                                <label 
                                                  className={`mr-10-desktop fsize-14 fweight-500 cl-neutral400`}
                                                  htmlFor="custom-time"
                                                >
                                                  I understand that it's [user’s account name]'s responsibility to stop sending marketing messages to customers who opt out.
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        </div>
                                        }
                                        {item?.typeCTA?.value === "custom" &&
                                        <div className='d-flex align-items-center w-100'>
                                          <div {...provided.dragHandleProps} className='cursor-pointer me-3'>
                                            <img src={IconDND} className=""></img>
                                          </div>
                                          <div className={`row mb-3 justify-content-between w-100`}>
                                            <div className='col-5 wrapp_input_button'>
                                              <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Type of Action</h4>
                                              <DropdownV3
                                                typeAction
                                                buttonData={val?.dataStructure?.buttons}
                                                isListSearch={TypeQuickReply} 
                                                setSelectedSearch={(value)=>handleDropdownType(value, idx, idxButton, index,val?.dataStructure?.buttons[idxButton], isOptionButtons)} 
                                                isSelected={item?.typeCTA}
                                                anySelected={isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons}
                                                placeholder="None"
                                              />
                                            </div>
                                            <div className="col-7">
                                              <div className='d-flex align-items-start w-100'>
                                                <div className='wrapp_input_button w-100'>
                                                  <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Button Text</h4>
                                                  <input
                                                    required={true}
                                                    type="text"
                                                    value={item?.text}
                                                    onChange={(e) =>
                                                      setChangeButtonOptions({
                                                        display: e.target.value,
                                                        content: item.content,
                                                        footer_marketing_disapproval: item.footer_marketing_disapproval,
                                                        idx: idx,
                                                        idxButton: idxButton,
                                                        index: index,
                                                        action: item.typeCTA.value === 'custom' ? 'custom' : 'marketing_disapproval',
                                                        term_condition: item?.term_condition,
                                                        footer_opt_out:  item?.footer_opt_out
                                                      })
                                                    }
                                                    placeholder="Enter text here"
                                                    error=""
                                                    className="form-control cl-neutral100"
                                                    maxLength={25}
                                                  />
                                                  <span className="count-char">{item?.text?.length}/25</span>
                                                </div>
                                                <div className='ms-3'>
                                                  <FeatherIcon onClick={()=>deleteTypeQuickReply(idx,idxButton,index)} icon="x" width="20" className="cursor-pointer cl-grey-smoke mb-2" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        }
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                )
                                })}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                      </div>
                    ) : ''}

                    {buttonCTA.length>0 && res.buttonType === 'CTA' ? (
                      <div className='wrapper_per_section_button'>
                        {res?.buttons.length>0 && (
                          <div onClick={()=>onSwitchSection(idx)} className='d-inline-flex align-items-center mb-3 cursor-pointer'>
                            <img src={IconSwitch} className="me-2"></img>
                            <p className='cl-black weight-medium fsize-14 mb-0'>Call to Action</p>
                          </div>
                        )}

                      <DragDropContext onDragEnd={(event)=>onDragEnd(event, res?.buttons, idxButton)}>
                      <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            // style={getListStyle(snapshot.isDraggingOver)}
                          >
                            {res?.buttons.map((item, index) => {
                              return (
                              <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    // style={getItemStyle(
                                    //   snapshot.isDragging,
                                    //   provided.draggableProps.style
                                    // )}
                                  >
                                    <div className='box-extra-button wrapper_footer_text mb-3'>
                                    {item?.typeCTA?.value === "call_phone_number" &&
                                      <div className='d-flex align-items-center w-100'>
                                        <div {...provided.dragHandleProps} className='cursor-pointer me-3'>
                                          <img src={IconDND} className=""></img>
                                        </div>
                                        <div className='w-100'>
                                          <div className='row mb-3 justify-content-between'>
                                          <div className='col-5 wrapp_input_button'>
                                            <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Type of Action</h4>
                                            <DropdownV3
                                              disabled
                                              buttonData={val?.dataStructure?.buttons}
                                              isListSearch={TypeCTA} 
                                              setSelectedSearch={(value)=>handleDropdownType(value,idx, idxButton, index,val?.dataStructure?.buttons[idxButton], isOptionButtons)} 
                                              isSelected={item?.typeCTA}
                                              anySelected={isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons}
                                              placeholder="None"
                                              typeAction
                                              // disableAction={item.disable}
                                            />
                                          </div>
                                          <div className='col-7'>
                                            <div className='d-flex align-items-start w-100'>
                                              <div className='wrapp_input_button w-100'>
                                                <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Phone Number</h4>
                                                <div className='wrapper_phone_input position-relative'>
                                                  <PhoneInput
                                                    ref={phoneInputRef}
                                                    // forceDialCode={true}
                                                    disableCountryGuess={true}
                                                    disableDialCodeAndPrefix={true}
                                                    showDisabledDialCodeAndPrefix={true}
                                                    disableDialCodePrefill={true}
                                                    charAfterDialCode={'              '}
                                                    defaultCountry="id"
                                                    value={item?.phone_number}
                                                    // onChange={(phone) => setPhone(phone)}
                                                    onChange={(phone) =>
                                                      setChangeButtonOptions({
                                                        display: item.text,
                                                        content: item.content,
                                                        idx: idx,
                                                        idxButton: idxButton,
                                                        index: index,
                                                        country: isOptionPhoneNumber?.value,
                                                        phoneNumber: phone,
                                                        action: 'phone_number',
                                                      })
                                                    }
                                                  />
                                                  <span className='border d-none'></span>
                                                </div>
                                                {/* <InputDropdown 
                                                  useSearch
                                                  typeInput="text"
                                                  customClass="country_code" 
                                                  isListSearch={listPhoneNumber} 
                                                  setSelectedSearch={(event)=>handleOptionPhoneNumber(event, idx, idxButton, index, val.dataStructure.buttons[idxButton].action)} 
                                                  isSelected={item.selectedPhoneNumber}
                                                  placeholder="None"
                                                  valueInput={item?.phone_number}
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: item.text,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      country: isOptionPhoneNumber?.value,
                                                      phoneNumber: e,
                                                      action: 'phone_number',
                                                    })
                                                  }
                                                /> */}
                                              </div>
                                              <div className='ms-3'>
                                                <FeatherIcon onClick={()=>deleteTypeQuickReply(idx, idxButton, index)} icon="x" className="cursor-pointer cl-grey-smoke" />
                                              </div>
                                            </div>
                                          </div>
                                          </div>
                                          <div className='row'>
                                            <div className='d-flex align-items-start w-100'>
                                              <div className="w-100 wrapp_input_button">
                                                <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Button Text</h4>
                                                <input
                                                  required={true}
                                                  type="text"
                                                  // defaultValue={res?.text}
                                                  value={item?.text}
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: e.target.value,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      action: 'phone_number',
                                                      phoneNumber: item.phone_number,
                                                      websiteUrl: item.websiteUrl,
                                                      sampleUrl: item.sampleUrl,
                                                      typeCta: 
                                                      item?.typeCTA.value === 'call_phone_number' ? 'call_phone_number' : 
                                                      item?.typeCTA.value === 'visit_web' ? 'visit_web' : 'copy_promo_code'
                                                    })
                                                  }
                                                  placeholder="Enter text here"
                                                  error=""
                                                  className="form-control cl-neutral100"
                                                  maxLength={25}
                                                />
                                                <span className="count-char">{item?.text?.length}/25</span>
                                              </div>
                                              <div className='ms-3 invisible'>
                                                <FeatherIcon onClick={()=>deleteTypeQuickReply(idx, idxButton, index)} icon="x" className="cursor-pointer cl-grey-smoke" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {item?.typeCTA?.value === "copy_promo_code" &&
                                    <div className='d-flex align-items-center w-100'>
                                        <div {...provided.dragHandleProps} className='cursor-pointer me-3'>
                                          <img src={IconDND} className=""></img>
                                        </div>
                                        <div className='w-100'>
                                          <div className='row mb-3 justify-content-between'>
                                          <div className='col-5 wrapp_input_button'>
                                            <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Type of Action</h4>
                                            <DropdownV3
                                              // countAction={item?.typeCTA.value === "copy_promo_code" ? 'copy_promo_code' : false}
                                              disabled
                                              buttonData={val?.dataStructure?.buttons}
                                              isListSearch={TypeCTA} 
                                              setSelectedSearch={(value)=>handleDropdownType(value,idx, idxButton, index,val?.dataStructure?.buttons[idxButton], isOptionButtons)} 
                                              isSelected={item?.typeCTA}
                                              anySelected={isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons}
                                              placeholder="None"
                                              typeAction
                                              // disableAction={item.disable}
                                            />
                                          </div>
                                          <div className='col-7'>
                                            <div className='d-flex align-items-start w-100'>
                                              <div className="w-100 wrapp_input_button">
                                                <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Button Text</h4>
                                                <input
                                                  required={true}
                                                  type="text"
                                                  disabled
                                                  // defaultValue={res?.text}
                                                  value={item?.text}
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: e.target.value,
                                                      copy_promo_code: item.copy_promo_code,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      action: 'copy_promo_code',
                                                      phoneNumber: item.phone_number,
                                                      websiteUrl: item.websiteUrl,
                                                      sampleUrl: item.sampleUrl,
                                                      typeCta: 
                                                        item?.typeCTA.value === 'call_phone_number' ? 'call_phone_number' : 
                                                        item?.typeCTA.value === 'visit_web' ? 'visit_web' : 'copy_promo_code'
                                                    })
                                                  }
                                                  placeholder="Enter text here"
                                                  error=""
                                                  className="form-control cl-neutral100"
                                                  maxLength={25}
                                                />
                                                <span className="count-char">{item?.text?.length}/25</span>
                                              </div>
                                              <div className='ms-3'>
                                                <FeatherIcon onClick={()=>deleteTypeQuickReply(idx, idxButton, index)} icon="x" className="cursor-pointer cl-grey-smoke" />
                                              </div>
                                            </div>
                                          </div>
                                          </div>
                                          <div className='row'>
                                            <div className='d-flex align-items-start w-100'>
                                              <div className="w-100 wrapp_input_button">
                                                <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Promo Code Sample</h4>
                                                <span className='d-block mb-2 fweight-400 fsize-12 cl-neutral100'>To help review your message templates, add an example for your promo code.</span>
                                                <div className='w-100 position-relative'>
                                                  <input
                                                    required={true}
                                                    type="text"
                                                    // defaultValue={res?.text}
                                                    value={item?.copy_promo_code}
                                                    onChange={(e) =>
                                                      setChangeButtonOptions({
                                                        ...props,
                                                        display: item.text,
                                                        websiteUrl: item.websiteUrl,
                                                        sampleUrl: item.sampleUrl,
                                                        content: item.content,
                                                        idx: idx,
                                                        idxButton: idxButton,
                                                        index: index,
                                                        action: 'copy_promo_code',
                                                        copy_promo_code: e.target.value,
                                                        phoneNumber: item.phone_number,
                                                        typeCta: 
                                                          item?.typeCTA.value === 'call_phone_number' ? 'call_phone_number' : 
                                                          item?.typeCTA.value === 'visit_web' ? 'visit_web' : 'copy_promo_code'
                                                      })
                                                    }
                                                    placeholder="Enter promo code sample...."
                                                    error=""
                                                    className="form-control cl-neutral100"
                                                    maxLength={15}
                                                  />
                                                  <span className="count-input">{item?.copy_promo_code?.length}/15</span>
                                                </div>
                                              </div>
                                              <div className='ms-3 invisible'>
                                                <FeatherIcon onClick={()=>deleteTypeQuickReply(idx, idxButton, index)} icon="x" className="cursor-pointer cl-grey-smoke" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {item?.typeCTA?.value === "visit_web" &&
                                    <div className='d-flex align-items-center w-100'>
                                        <div {...provided.dragHandleProps} className='cursor-pointer me-3'>
                                          <img src={IconDND} className=""></img>
                                        </div>
                                        <div className='w-100'>
                                          <div className='row mb-3 justify-content-between'>
                                            <div className='col-5 wrapp_input_button'>
                                              <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Type of Action</h4>
                                              <DropdownV3
                                                disabled
                                                buttonData={val?.dataStructure?.buttons}
                                                isListSearch={TypeCTA} 
                                                setSelectedSearch={(value)=>handleDropdownType(value,idx, idxButton, index,val?.dataStructure?.buttons[idxButton], isOptionButtons)} 
                                                isSelected={item?.typeCTA}
                                                anySelected={isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons}
                                                placeholder="None"
                                                typeAction
                                              />
                                            </div>
                                            <div className='col-7'>
                                              <div className='d-flex align-items-start w-100'>
                                                <div className='wrapp_input_button w-100'>
                                                  <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">URL Type</h4>
                                                  <DropdownV3
                                                    isListSearch={UrlTypeCTA} 
                                                    setSelectedSearch={(val)=>handleDropdownUrlType({idx: idx, idxButton: idxButton, index: index, value:val},isOptionButtons)} 
                                                    isSelected={item?.urlType}
                                                    placeholder="None"
                                                  />
                                                </div>
                                                <div className='ms-3'>
                                                  <FeatherIcon onClick={()=>deleteTypeQuickReply(idx, idxButton, index)} icon="x" className="cursor-pointer cl-grey-smoke" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className='row mb-2 justify-content-between'>
                                            <div className="col-12 wrapp_input_button mb-3">
                                              <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Button Text</h4>
                                              <input
                                                required={true}
                                                type="text"
                                                // defaultValue={res?.text}
                                                value={item?.text}
                                                onChange={(e) =>
                                                  setChangeButtonOptions({
                                                    ...props,
                                                    display: e.target.value,
                                                    content: item.content,
                                                    idx: idx,
                                                    idxButton: idxButton,
                                                    index: index,
                                                    action: 'visit_web',
                                                    phoneNumber: item.phone_number,
                                                    websiteUrl: item.websiteUrl,
                                                    sampleUrl: item.sampleUrl,
                                                    typeCta: 
                                                    item?.typeCTA.value === 'call_phone_number' ? 'call_phone_number' : 
                                                    item?.typeCTA.value === 'visit_web' ? 'visit_web' : 'copy_promo_code'
                                                  })
                                                }
                                                placeholder="Enter text here"
                                                error=""
                                                className="form-control cl-neutral100"
                                                maxLength={25}
                                              />
                                              <span className="count-char">{item?.text?.length}/25</span>
                                            </div>
                                            <div className="col-12 wrapp_input_button mb-3">
                                              <h4 className="cl-neutral400 fweight-600 fsize-14 mb-2">Website URL</h4>
                                              <div className='position-relative d-flex align-items-center'>
                                                <input
                                                  required={true}
                                                  type="text"
                                                  value={item?.websiteUrl}
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: item.text,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      websiteUrl: e.target.value,
                                                      sampleUrl: item.sampleUrl,
                                                      action: 'visit_web',
                                                      typeCta : 
                                                      item?.typeCTA.value === 'call_phone_number' ? 'call_phone_number' : 
                                                      item?.typeCTA.value === 'visit_web' ? 'visit_web' : 'copy_promo_code'
                                                    })
                                                  }
                                                  placeholder="https://...."
                                                  error=""
                                                  className="form-control cl-neutral100 input_website"
                                                  maxLength={2000}
                                                />
                                                <span className="count-char-website me-3">{item?.websiteUrl?.length}/2000</span>
                                                {item?.urlType?.value === 'url_dynamic' &&
                                                  <div className='dynamic_url d-flex align-items-center'>
                                                    <OverlayTrigger
                                                      placement="right"
                                                      overlay={<Tooltip id="button-tooltip-2">Adding a variable creates a personalised link for the customer to view their info. Only one variable can be added to the end of a URL. 
                                                      </Tooltip>}
                                                    >
                                                      <span className='d-flex'>
                                                        <FeatherIcon icon="info" className="cursor-pointer cl-black" />
                                                      </span>
                                                    </OverlayTrigger>
                                                  </div>
                                                }
                                              </div>
                                              {isErrorUrl && 
                                                <span className='fsize-12 fweight-400 cl-red'>Please enter a valid URL</span>
                                              }
                                            </div>
                                            {item?.urlType?.value === 'url_dynamic' &&
                                            <div className="col-12 wrapp_input_button">
                                              <h4 className="cl-neutral400 fweight-600 fsize-14 mb-1">Add Sample URL</h4>
                                              <span className='d-block mb-2 fweight-400 fsize-12 cl-neutral100'>
                                                Please add an example of the website URL. Do not use real customer information.
                                              </span>
                                              <div className='position-relative d-flex align-items-center'>
                                                <span className='cl-black fsize-14 me-2'>{isVarDynamicWeb}</span>
                                                <input
                                                  required={true}
                                                  type="text"
                                                  value={item?.sampleUrl}
                                                  onChange={(e) =>
                                                    setChangeButtonOptions({
                                                      display: item.text,
                                                      content: item.content,
                                                      idx: idx,
                                                      idxButton: idxButton,
                                                      index: index,
                                                      websiteUrl: item.websiteUrl,
                                                      sampleUrl: e.target.value,
                                                      action: 'visit_web',
                                                      typeCta : 
                                                      item?.typeCTA.value === 'call_phone_number' ? 'call_phone_number' : 
                                                      item?.typeCTA.value === 'visit_web' ? 'visit_web' : 'copy_promo_code'
                                                    })
                                                  }
                                                  placeholder={`Enter full URL for ${item?.websiteUrl && !isErrorUrl ? `${item?.websiteUrl}/{{1}}` : 'https://example.co.id/{{1}}'}`}
                                                  error=""
                                                  className="form-control cl-neutral100 input_website"
                                                  maxLength={2000} 
                                                />
                                                {/* <span className="count-char-website">{item?.sampleUrl?.length}/2000</span> */}
                                              </div>
                                              {item?.urlType?.value === 'url_dynamic' && !item?.sampleUrl && 
                                                <div
                                                  className={`d-flex align-items-center mt-3 box-info info-required`}
                                                >
                                                  <img src={AlertTriangle}></img>
                                                  <span className="ms-2">
                                                    Add sample URL is required.
                                                  </span>
                                                </div>
                                              
                                              }
                                            </div>
                                            }
                                        </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  </div>
                                )}
                              </Draggable>
                              )
                            })}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                      </DragDropContext>
                      </div>
                    ) : ''}
                    </div>
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default AddButtonTemplate